import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { fetchBrowse, type BrowseQuery } from '@/api/discovery'
import type { BrowsePage } from '@/api/types'

export const BROWSE_QUERY_KEY = ['browse'] as const

export const useBrowse = (query: BrowseQuery) =>
  useQuery<BrowsePage>({
    queryKey: [...BROWSE_QUERY_KEY, query],
    queryFn: () => fetchBrowse(query),
    placeholderData: keepPreviousData,
    // Phase 8: signed hero URLs in browse results expire at 1 hour; keep the data fresh just
    // under that so cards don't show broken thumbs after a long browse session.
    staleTime: 50 * 60 * 1000,
  })
